import { useMsal } from '@azure/msal-react';
import {
  ComboBox,
  DatePicker,
  DefaultButton,
  Dropdown,
  IComboBoxOption,
  IDropdownOption,
  Icon,
  IconButton,
  Label,
  PrimaryButton,
  Separator,
  Spinner,
  SpinnerSize,
  Stack,
  Text,
  TextField,
  Toggle,
  mergeStyles
} from '@fluentui/react';
import { useEffect, useRef, useState } from "react";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../../assets/styles/app.css';
import '../../assets/styles/site-entry.css';
import { NewEntrySite, japaneseStrings, listname } from '../../constants/global-values';
import { addSiteEntry, updateItem } from '../../services/graph-service';
import { RootState } from '../../store/store';
import { fetchItemById, getTokenAndListInfo, japaneseDateConverter, phoneNumFormat, useSmartBack, validatePhone } from '../../utils/item-helper';
import { common, formatMessage } from '../../messages/common-items';
import { personalInformation } from '../../messages/personal-Information';
import { siteentrylist } from '../../messages/site-entry';
import SignaturePad, { SignaturePadRef } from "../../components/signature-pad";
import FileUpload from '../../components/file-upload';
import { ALL_CONTRACTORS_OPTIONS, BLOOD_PRESSURE_OPTIONS, BLOOD_TYPE_OPTIONS, BODY_TEMP_OPTIONS, CONDITION_OPTIONS, EMERGENCY_RELATION_OPTIONS, GENDER_OPTIONS, INJURY_OPTIONS, JOBTYPE_OPTIONS, QUALIFICATION_OPTIONS, ROLE_OPTIONS } from '../../constants/options';
import React from 'react';

export default function SiteEntryAdd() {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [errors, setErrors] = useState<any>({});
  const goBack = useSmartBack("/");
  const phoneUser = useSelector((state: RootState) => state.global.phoneUser);
  const user_Leaderid = phoneUser?.userId ?? "";
  const [selectedDate, setSelectedDate] = React.useState<{ entryDate: Date | null }>({ entryDate: null });
  type phoneNumberField = "PhoneNumber" | "EmergencyPhone";
  const [item, setItem] = useState<any>(null);
  const [phoneNumber, setPhoneNumber] = useState<Record<phoneNumberField, string>>({
    PhoneNumber: "",
    EmergencyPhone: ""
  });
  const [siteId, setSiteId] = useState("");
  const [listId, setListId] = useState("");
  const [token, setToken] = useState("");
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [expanded, setExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const { Labels: Lbl_Common, SuccessMessages: Success_Common, ErrorMessages: Err_Common } = common;
  const { Labels: Lbl_Personal_Info, SuccessMessages: Success_Personal_Info } = personalInformation;
  const { Labels: Lbl_New_Entry } = siteentrylist;

  useEffect(() => {
    const fetch = async () => {
      try {
        const { token, siteId, listId } = await getTokenAndListInfo(instance, listname);
        const found = await fetchItemById(token, siteId, listId, user_Leaderid!);
        setItem(found);
        setSiteId(siteId);
        setListId(listId);
        setToken(token)
      }
      catch (error) {
        console.error("Error loading item", error);
      }
    };
    fetch();
  }, [expanded]);

  const handleChange = (key: string, value: any) => {
    setItem({ ...item, [key]: value ?? "" });
  };

  const validateAndSubmit = () => {
    const newErrors: any = {};
    if (!formData.EntryDate) {
      newErrors.EntryDate = formatMessage(Err_Common.REQUIRED_SELECT, Lbl_New_Entry.ENTRY_DATE_LBL);
    }
    if (!formData.PartnerName?.trim()) {
      newErrors.PartnerName = formatMessage(Err_Common.REQUIRED_SELECT, Lbl_New_Entry.PARTNER_NAME_LBL);
    }
    if (!formData.Role?.trim()) {
      newErrors.Role = formatMessage(Err_Common.REQUIRED_SELECT, Lbl_New_Entry.ROLE_LBL);
    }

    setErrors(newErrors);

    // Focus first error
    const firstErrorKey = Object.keys(newErrors)[0];
    if (firstErrorKey) {
      const el = document.getElementById(firstErrorKey);
      const input = el?.querySelector("input") as HTMLInputElement | null;
      input?.focus();
      return false;
    }
    return true;
  };

  const validateAndSubmit_user = () => {
    const newErrors: any = {};
    if (!item.Name.trim())
      newErrors.Name = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.NAME);
    if (!item.Gender?.trim()) {
      newErrors.Gender = formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.GENDER);
    }
    if (!item.Address?.trim()) {
      newErrors.Address = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.ADDRESS);
    }
    if (!item.PhoneNumber.trim()) {
      newErrors.PhoneNumber = formatMessage(Success_Personal_Info.PHONE_VALID);
    } else if (!(validatePhone(item.PhoneNumber))) {
      newErrors.PhoneNumber = formatMessage(Err_Common.INVALID_PHONE_ERR);
    }
    if (!item.EmergencyPhone?.trim()) {
      newErrors.EmergencyPhone = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL);
    } else if (!validatePhone(item.EmergencyPhone)) {
      newErrors.EmergencyPhone = formatMessage(Err_Common.INVALID_PHONE_ERR);
    }
    if (!item.EmergencyName?.trim()) {
      newErrors.EmergencyName = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_NAME);
    }
    if (!item.JobType?.trim()) {
      newErrors.JobType = formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.JOB_TYPE);
    }
    setErrors(newErrors);
    const firstErrorKey = Object.keys(newErrors)[0];
    if (firstErrorKey) {
      const el = document.getElementById(firstErrorKey);
      if (el) (el as HTMLInputElement).focus();
      return;
    }
    return Object.keys(newErrors).length === 0;
  };

  const [filteredOptions, setFilteredOptions] = useState<IComboBoxOption[]>(ALL_CONTRACTORS_OPTIONS);
  const [contractorQuery, setContractorQuery] = useState("");

  const safeOptions: IComboBoxOption[] = Array.isArray(filteredOptions) ? filteredOptions : [];

  // const handleInputChange = (newValue: string): void => {
  //   if (newValue) {
  //     const search = newValue.toLowerCase();
  //     const results = ALL_CONTRACTORS_OPTIONS.filter((option) =>
  //       option.text.toLowerCase().includes(search)   // contains match
  //     );
  //     setFilteredOptions(results);
  //   } else {
  //     setFilteredOptions(ALL_CONTRACTORS_OPTIONS); // reset when empty
  //   }
  // }
  const handleInputChange = (value?: string) => {
    const newValue = value ?? "";
    setContractorQuery(newValue);

    const search = newValue.trim().toLowerCase();
    if (!search) {
      setFilteredOptions(ALL_CONTRACTORS_OPTIONS);
      return;
    }
    setFilteredOptions(
      ALL_CONTRACTORS_OPTIONS.filter(o => o.text.toLowerCase().includes(search))
    );
  };
  const [formData, setFormData] = useState({
    EntryDate: null,
    WorkerId: user_Leaderid,
    Role: "",
    ConditionNote: "",
    InjuryNote: "",
    BloodPressure: "",
    BodyTemperature: "",
    Signature: "",
    PartnerName: "",
  });
  const [loading, setLoading] = useState(false);
  const sigRef = useRef<SignaturePadRef>(null);
  const handleSave = async () => {
    const signature = sigRef.current?.getSignature();
    const { token, siteId, listId } = await getTokenAndListInfo(instance, NewEntrySite);
    const newItem = await addSiteEntry(token, siteId, listId, formData);
    setLoading(false);
    navigate(`/shinki/kyouiku`, { state: { from: "newentry" } });
  };

  const updateField = (field: string, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev: any) => ({ ...prev, [field]: "" }));
  };
  const SectionHeader: React.FC<{ title: string }> = ({ title }) => (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }}>
      <Label styles={{ root: { whiteSpace: "nowrap", marginLeft: 15 } }}>{title}</Label>
      <Separator styles={{ root: { flexGrow: 1 } }} />
    </Stack>
  );
  const handlePhoneNumberChange = (
    field: 'PhoneNumber' | 'EmergencyPhone',
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const input = event.currentTarget.value;
    const digits = input.replace(/\D/g, '').slice(0, 11);
    let formattedPhoneNum = phoneNumFormat(digits);
    setPhoneNumber(prev => ({
      ...prev,
      [field]: formattedPhoneNum,
    }));
    const numFormat = formattedPhoneNum.replace(/-/g, "");
    handleChange(field, numFormat);
  };
  const handleQualificationsChange = (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption
  ) => {
    if (!option) return;
    let updated = [...selectedOptions];
    if (option.selected) {
      updated.push(option.text);
    } else {
      updated = updated.filter(item => item !== option.text);
    }
    setSelectedOptions(updated);
    handleChange("Qualifications", updated);
  };
  const handleSave_worker = async () => {
    await updateItem(token, siteId, listId, item.id, item);
    setExpanded(!expanded);
    setIsEditing(false);
  };
  if (!item) {
    return <div className="loadercommon-container">
      <Spinner label={Success_Common.LOADER_MSG} size={SpinnerSize.large} />
    </div>;
  }

  return (
    <div className="background  list-background">
      <div className="form-container list-box">
        <div className="new-form-container">
          <Stack tokens={{ childrenGap: 10 }}>
            <Stack
              horizontal
              horizontalAlign="space-between"
              verticalAlign="center">
              <h2>
                {Lbl_Personal_Info.ADD}
              </h2>
            </Stack>
            {!expanded && (
              <>
                <Stack className="cardWrapperCollapse" tokens={{ childrenGap: 4 }}>
                  <Stack horizontal verticalAlign="center" styles={{ root: { width: "100%" } }}>
                    <Text
                      variant="large"
                      className="value-text"
                      styles={{ root: { fontWeight: 600, flexGrow: 1 } }}>
                      {item.Name}
                    </Text>
                    <IconButton
                      iconProps={{ iconName: expanded ? "Remove" : "Add" }}
                      className="toggleButton"
                      onClick={() => {
                        setExpanded(!expanded);
                        setIsEditing(false);
                      }} />
                  </Stack>
                  <Stack
                    horizontal
                    verticalAlign="center"
                    tokens={{ childrenGap: 6 }}
                    styles={{ root: { width: "100%" } }}>
                    <Icon iconName="POI" styles={{ root: { width: 20, textAlign: "center" } }} />
                    <Text styles={{ root: { flexGrow: 1 } }}>
                      {item.Address}
                    </Text>
                  </Stack>
                  <Stack
                    horizontal
                    verticalAlign="center"
                    tokens={{ childrenGap: 6 }}
                    styles={{ root: { width: "100%" } }}>
                    <Icon iconName="Phone" styles={{ root: { width: 20, textAlign: "center" } }} />
                    <Text className="label-text" styles={{ root: { flexGrow: 1 } }}>
                      {phoneNumFormat(item.PhoneNumber)}
                    </Text>
                  </Stack>
                </Stack>
              </>
            )}
            {expanded && (
              <Stack className="cardWrapper" tokens={{ childrenGap: 10 }} >
                <Stack horizontal style={{
                  justifyContent: 'space-between'
                }}>
                  <IconButton
                    iconProps={{ iconName: "Remove" }}
                    onClick={() => setExpanded(false)}
                  />
                  {!isEditing && (
                    <DefaultButton
                      iconProps={{ iconName: "Edit" }}
                      text={Lbl_Common.EDIT}
                      className="edit-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsEditing(true);
                      }}
                    />
                  )}
                </Stack>
                <Stack style={{ pointerEvents: isEditing ? "auto" : "none", opacity: isEditing ? 1 : 0.9 }} tokens={{ childrenGap: 10 }}>
                  <SectionHeader title={Lbl_Personal_Info.BASIC_INFO_LBL} />
                  <TextField
                    required
                    label={Lbl_Personal_Info.NAME}
                    placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.NAME)}
                    value={item.Name}
                    onChange={(_, val) => handleChange("Name", val)}
                    errorMessage={errors.Name}
                  />
                  {
                    <DatePicker
                      label={Lbl_Personal_Info.DATEOFBIRTH}
                      placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.DATEOFBIRTH)}
                      strings={japaneseStrings}
                      value={item.DateOfBirth ? new Date(item.DateOfBirth) : undefined}
                      onSelectDate={(date) => {
                        handleChange("DateOfBirth", date);
                      }}
                      formatDate={japaneseDateConverter}
                    />
                  }
                  <Dropdown
                    required
                    label={Lbl_Personal_Info.GENDER}
                    placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.GENDER)}
                    selectedKey={item.Gender}
                    options={GENDER_OPTIONS}
                    onChange={(_, o) => handleChange("Gender", o?.key)}
                    errorMessage={errors.Gender} />
                  <TextField
                    required
                    label={Lbl_Personal_Info.ADDRESS}
                    placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.ADDRESS)}
                    value={item.Address}
                    onChange={(_, val) => handleChange("Address", val)}
                    errorMessage={errors.Address} />
                  <TextField
                    label={Lbl_Personal_Info.PHONENUMBER}
                    required
                    placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.PHONENUMBER)}
                    id="PhoneNumber"
                    type="tel"
                    value={item.PhoneNumber ? phoneNumFormat(item.PhoneNumber) : ""}
                    onChange={(e) => handlePhoneNumberChange("PhoneNumber", e)}
                    maxLength={13}
                    autoComplete="tel"
                    errorMessage={errors.PHONENUMBER}
                  />
                  <SectionHeader title={Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL} />
                  <TextField
                    required
                    label={Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL}
                    placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL)}
                    id="EmergencyPhone"
                    type="tel"
                    value={item.EmergencyPhone ? phoneNumFormat(item.EmergencyPhone) : ""}
                    onChange={(e) => handlePhoneNumberChange("EmergencyPhone", e)}
                    maxLength={13}
                    autoComplete="tel"
                    errorMessage={errors.EMERGENCY_PHONENUMBER_LBL}
                  />
                  <TextField
                    required
                    label={Lbl_Personal_Info.EMERGENCY_NAME}
                    placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_NAME)}
                    value={item.EmergencyName}
                    onChange={(_, val) => handleChange("EmergencyName", val)}
                    errorMessage={errors.EmergencyName} />
                  <Dropdown
                    label={Lbl_Personal_Info.EMERGENCY_RELATION}
                    placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.EMERGENCY_RELATION)}
                    id="EmergencyRelation"
                    options={EMERGENCY_RELATION_OPTIONS}
                    onChange={(_, o) => handleChange("EmergencyRelation", o?.text)} />
                  <Toggle
                    label={Lbl_Personal_Info.IS_SOLE_PROPRIETOR}
                    checked={item.IsSoleProprietor === Lbl_Personal_Info.YES_OPTION}
                    onChange={(_, checked) =>
                      handleChange("IsSoleProprietor", checked ? Lbl_Personal_Info.YES_OPTION : Lbl_Personal_Info.NO_OPTION)
                    }
                  />
                  <Toggle
                    label={Lbl_Personal_Info.SPECIAL_LABOR_INSURANCE}
                    checked={item.SpecialLaborInsurance === Lbl_Personal_Info.YES_OPTION}   // true if "はい"
                    onChange={(_, checked) =>
                      handleChange("SpecialLaborInsurance", checked ? Lbl_Personal_Info.YES_OPTION : Lbl_Personal_Info.NO_OPTION)
                    }
                  />
                  <TextField
                    label={Lbl_Personal_Info.PARTNER_COMPANY_LBL}
                    placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.PARTNER_COMPANY_LBL)}
                    id="PartnerName"
                    value={item.PartnerName}
                    onChange={(_, val) => handleChange("PartnerName", val)} errorMessage={errors.PartnerName} />
                  <SectionHeader title={Lbl_Personal_Info.HEALTH_INFO_LBL} />
                  <Dropdown
                    label={Lbl_Personal_Info.BLOOD_TYPE}
                    placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.BLOOD_TYPE)}
                    selectedKey={item.BloodType}
                    options={BLOOD_TYPE_OPTIONS}
                    onChange={(_, o) => handleChange("BloodType", o?.key)} />
                  {
                    <DatePicker
                      label={Lbl_Personal_Info.HEALTH_CHECK_DATE}
                      placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.HEALTH_CHECK_DATE)}
                      strings={japaneseStrings}
                      value={item.HealthCheckDate ? new Date(item.HealthCheckDate) : undefined}
                      onSelectDate={(date) => {
                        handleChange("HealthCheckDate", date);
                      }}
                      formatDate={japaneseDateConverter}
                    />
                  }
                  <SectionHeader title={Lbl_Personal_Info.OCCUPATION_INFO_LBL} />
                  <Dropdown
                    required
                    label={Lbl_Personal_Info.JOB_TYPE}
                    placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.JOB_TYPE)}
                    selectedKey={item.JobType}
                    options={JOBTYPE_OPTIONS}
                    onChange={(_, o) => handleChange("JobType", o?.key)}
                    errorMessage={errors.JobType} />
                  <Dropdown
                    label={Lbl_Personal_Info.QUALIFICATIONS}
                    placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.QUALIFICATIONS)}
                    id="Qualifications"
                    multiSelect
                    selectedKeys={selectedOptions}
                    options={QUALIFICATION_OPTIONS}
                    onChange={handleQualificationsChange}
                  />
                  {
                    <DatePicker
                      label={Lbl_Personal_Info.QUALIFICATION_EXPIRY}
                      placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.QUALIFICATION_EXPIRY)}
                      strings={japaneseStrings}
                      value={item.QualificationExpiry ? new Date(item.QualificationExpiry) : undefined}
                      onSelectDate={(date) => {
                        handleChange("QualificationExpiry", date);
                      }}
                      formatDate={japaneseDateConverter}
                    />
                  }
                  <FileUpload
                    label={Lbl_Personal_Info.QUALIFICATION_PHOTO_LBL}
                    placeholder={Success_Personal_Info.NO_IMAGE_SELECTED}
                    onFileSelect={(files) => handleChange("CertificatePhotos", files)}
                  />
                  <FileUpload
                    label={Lbl_Personal_Info.FACE_PHOTOS_LBL}
                    placeholder={Success_Personal_Info.NO_IMAGE_SELECTED}
                    onFileSelect={(files) => handleChange("FacePhotos", files)}
                  />
                </Stack>
                {isEditing && (
                  <Stack horizontal className="buttonallign" tokens={{ childrenGap: 8 }}>
                    <PrimaryButton
                      className="custom-primary-button"
                      text={Lbl_Common.SAVE}
                      onClick={() => {
                        if (validateAndSubmit_user()) {
                          setLoading(true);
                          handleSave_worker();
                        }
                      }}
                    />
                    <PrimaryButton className="cancel-button" text={Lbl_Common.CANCEL}
                      onClick={() => {
                        setIsEditing(false);
                        setExpanded(false);
                      }}
                    />
                  </Stack>
                )}
              </Stack>
            )}
          </Stack>
          <Separator />
          <h2>
            {Lbl_New_Entry.NEW_ENTRY}
          </h2>
          <Stack className="cardWrapper" tokens={{ childrenGap: 10 }}>
            <Label>
              {siteentrylist.Labels.ENTRY_DATE_LBL}
              <span className="label-required"> *</span>
            </Label>
            <DatePicker
              id="EntryDate"
              className={`customDatePicker ${errors.EntryDate ? "error" : ""}`}
              strings={japaneseStrings}
              value={selectedDate.entryDate ?? undefined}
              placeholder={formatMessage(
                Err_Common.REQUIRED_SELECT,
                Lbl_New_Entry.ENTRY_DATE_LBL
              )}
              onSelectDate={(date) => {
                const selDate = date ?? null;
                setSelectedDate((prev) => ({
                  ...prev,
                  entryDate: selDate,
                }));
                updateField("EntryDate", date);
                if (errors.EntryDate) {
                  setErrors((prev: any) => ({ ...prev, EntryDate: undefined }));
                }
              }}
              formatDate={japaneseDateConverter}
            />
            {errors.EntryDate && (
              <div className="error-message">{errors.EntryDate}</div>
            )}

            <ComboBox
              required
              errorMessage={errors.PartnerName}
              label={siteentrylist.Labels.PARTNER_NAME_LBL}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, siteentrylist.Labels.PARTNER_NAME_LBL)}
              options={safeOptions}
              allowFreeInput
              autoComplete="on"
              onInputValueChange={handleInputChange}
              onChange={(_, option) => {
                updateField("PartnerName", option ? String(option.key) : "");
              }}
              styles={{ root: { width: "100%" } }}
              calloutProps={{
                doNotLayer: true, // keeps dropdown inside parent
                styles: { root: { width: "100%" }, calloutMain: { width: "100%" } }
              }}
            />
            <Dropdown label={Lbl_New_Entry.ROLE_LBL} required
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_New_Entry.ROLE_LBL)}
              id="Role"
              errorMessage={errors.Role}
              options={ROLE_OPTIONS} onChange={(_, val) => updateField("Role", val?.text)} />
            <Dropdown label={Lbl_New_Entry.HEALTH_CONDITION_LBL} id="ConditionNote"
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_New_Entry.HEALTH_CONDITION_LBL)}
              options={CONDITION_OPTIONS} onChange={(_, val) => updateField("ConditionNote", val?.text)} />
            <Dropdown label={Lbl_New_Entry.INJURY_NOTE_LBL} id="InjuryNote"
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_New_Entry.INJURY_NOTE_LBL)}
              options={INJURY_OPTIONS} onChange={(_, val) => updateField("InjuryNote", val?.text)} />
            <Dropdown label={Lbl_New_Entry.BLOOD_PRESSURE_LBL} id="BloodPressure"
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_New_Entry.BLOOD_PRESSURE_LBL)}
              options={BLOOD_PRESSURE_OPTIONS} onChange={(_, val) => updateField("BloodPressure", val?.text)} />
            <Dropdown label={Lbl_New_Entry.BODY_TEMPERATURE_LBL} id="BodyTemperature"
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_New_Entry.BODY_TEMPERATURE_LBL)}
              options={BODY_TEMP_OPTIONS} onChange={(_, val) => updateField("BodyTemperature", val?.text)} />
            <label className="signatureLabel">
              {Lbl_New_Entry.SIGNATURE_LBL}
            </label>
            <SignaturePad ref={sigRef} height={150}
              onChange={(val) => updateField("Signature", val)}
            />
            <Stack horizontal className="buttonallign" tokens={{ childrenGap: 8 }}>
              <PrimaryButton
                className="custom-primary-button"
                text={Lbl_New_Entry.NEW_REGISTRATION_BTN} onClick={() => {
                  if (validateAndSubmit()) {
                    setLoading(true);
                    handleSave();
                  }
                }} />
              <PrimaryButton className="cancel-button" text={Lbl_Common.CANCEL} onClick={goBack} />
            </Stack>
          </Stack>
        </div>
      </div>
    </div>
  );
};